import styled from 'styled-components'

const MarginLabelUi = styled.label`
  display: flex;
  justify-content: center;
  cursor: pointer;
`

export default MarginLabelUi
